import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { HttpLink } from "apollo-link-http";
import { onError } from "apollo-link-error";
import { withClientState } from "apollo-link-state";
import { ApolloLink, Observable } from "apollo-link";

const setToken = token => {
  window.localStorage.setItem("ccZestyAuthToken", token);
};

const getToken = () => {
  const token = window.localStorage.getItem("ccZestyAuthToken");
  return `Bearer ${token}`;
};

const deleteToken = () => {
  window.localStorage.removeItem("ccZestyAuthToken");
  window.localStorage.removeItem("zg-cc-auth-userId");
};

const httpLink = new HttpLink({
  uri: "https://cuisinecrafters.net/apis/graphql",
  // uri: "http://localhost:4000/graphql",
  credentials: "same-origin"
});

const request = async operation => {
  const token = getToken();
  operation.setContext({
    headers: {
      authorization: token
    }
  });
};

const requestLink = new ApolloLink(
  (operation, forward) =>
    new Observable(observer => {
      let handle;
      Promise.resolve(operation)
        .then(oper => request(oper))
        .then(() => {
          handle = forward(operation).subscribe({
            next: observer.next.bind(observer),
            error: observer.error.bind(observer),
            complete: observer.complete.bind(observer)
          });
        })
        .catch(observer.error.bind(observer));

      return () => {
        if (handle) handle.unsubscribe();
      };
    })
);

const afterWareLink = new ApolloLink((operation, forward) => {
  return forward(operation).map(response => {
    const context = operation.getContext();
    const {
      response: { headers }
    } = context;

    let authorization;

    if (headers.get("authorization") != null || headers.get("authorization") != undefined) {
      authorization = headers.get("authorization");
      setToken(authorization);
    }

    let newResponse = {
      ...response,
      authorization
    };

    return newResponse;
  });
});

const cache = new InMemoryCache();

export const client = new ApolloClient({
  link: ApolloLink.from([
    onError(({ graphQLErrors, networkError }) => {
      //console.log(graphQLErrors, networkError, "graphQl error");
      if (graphQLErrors) {
        // sendToLoggingService(graphQLErrors);
        if (graphQLErrors.length > 0) {
          const errMsg = graphQLErrors[0].message
            ? graphQLErrors[0].message
            : "";
          // if (errMsg == "jwt expired" ||  errMsg.startsWith('Variable "$chefId" got invalid value null') || errMsg.startsWith('Variable "$userId" got invalid value null')) {
          if (errMsg == "jwt expired") {
            deleteToken();
            // alert("Token Expired. Please login again");
            window.location =
              window.location.protocol + "//" + window.location.host + "/unauthorized";
          }
        }
      }
      if (networkError) {
        // logoutUser();
      }
    }),
    requestLink,
    afterWareLink,
    withClientState({
      defaults: {
        isConnected: true
      },
      resolvers: {
        Mutation: {
          updateNetworkStatus: (_, { isConnected }, { cache }) => {
            //console.log(cache, "cacheData");
            cache.writeData({ data: { isConnected } });
            return null;
          }
        }
      },
      Query: () => ({}),
      Mutate: () => ({}),
      cache
    }),
    httpLink
  ]),
  cache
});
